import { writable } from 'svelte/store';

import { JUMP_TYPE_ENUM } from '../enums';

import url from '@/utils/url';

export const isLogin = writable(false);
export const userID = writable('');
export const PhoneCell = writable('');
export const cookieHeight = writable(0);
export const bottomButtonHeight = writable(0);
export const isCookiesShow = writable(false);
export const omegaParams = writable<Record<string, unknown>>({});
export const visible = writable(true);
export const isJumpOneLink = writable(false);
export const jumpType = writable(JUMP_TYPE_ENUM.TO_H5CREDITCARD);
export const pageId = writable(url.get('pageId') || '');
export const startTime = writable(Date.now());
export const regPageExposeAt = writable(0);
